import { render } from "./BuildPack.vue?vue&type=template&id=62a85584&scoped=true"
import script from "./BuildPack.vue?vue&type=script&lang=js"
export * from "./BuildPack.vue?vue&type=script&lang=js"

import "./BuildPack.vue?vue&type=style&index=0&id=62a85584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a85584"]])

export default __exports__